module.exports = __webpack_public_path__ + "img/2-r.811898e1.png";